var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "CANADA_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_64173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000007412665403631271880000017313914514663039650_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.0777 0.105469H0.514648V19.6835H34.0777V0.105469Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_64173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.41065 0.105469H0.514648V19.6835H8.41065V0.105469Z",
    fill: "#EA0020"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_64173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000007412665403631271880000017313914514663039650__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0777 0.105469H0.514648V19.6835H34.0777V0.105469Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_64173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.0766 0.105469H26.1816V19.6835H34.0766V0.105469Z",
    fill: "#EA0020"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_64173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000007412665403631271880000017313914514663039650__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.0777 0.105469H0.514648V19.6835H34.0777V0.105469Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_64173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.1802 0.105469H8.40918V19.6835H26.1802V0.105469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_64173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000007412665403631271880000017313914514663039650__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.0777 0.105469H0.514648V19.6835H34.0777V0.105469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_64173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_64173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000116927155514219881680000014891254825377363596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.0777 0.105469H0.514648V19.6835H34.0777V0.105469Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_64173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.2959 2.64453L16.1309 4.90652C15.9989 5.15252 15.7629 5.12752 15.5259 4.99152L14.6819 4.53552L15.3109 8.01251C15.4439 8.64851 15.0189 8.6485 14.8099 8.3735L13.3389 6.65753L13.0999 7.52753C13.0739 7.64053 12.9529 7.76252 12.7699 7.73352L10.9109 7.32452L11.3989 9.17551C11.5049 9.58851 11.5849 9.75952 11.2939 9.86752L10.6309 10.1915L13.8339 12.9015C13.9589 13.0055 14.0249 13.1865 13.9779 13.3545L13.6989 14.3135C14.7999 14.1815 15.7909 14.0605 16.8899 13.9275C16.9879 13.9275 17.1519 14.0145 17.1509 14.1315L17.0049 17.6415H17.5419L17.4559 14.1395C17.4559 14.0255 17.6039 13.9275 17.6999 13.9275C18.8039 14.0605 19.7919 14.1815 20.8939 14.3135L20.6119 13.3545C20.5689 13.1865 20.6329 13.0045 20.7579 12.9015L23.9599 10.1915L23.2969 9.86752C23.0049 9.75952 23.0869 9.58851 23.1919 9.17551L23.6809 7.32452L21.8209 7.73352C21.6379 7.76252 21.5179 7.64053 21.4909 7.52753L21.2529 6.65753L19.7809 8.3735C19.5719 8.6475 19.1479 8.64751 19.2809 8.01251L19.9079 4.53552L19.0669 4.99152C18.8289 5.12752 18.5909 5.15252 18.4619 4.90652L17.2959 2.64453Z",
    fill: "#EA0020"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.6faf966aaa5201d498c538f6620b91c2.svg";
export { ForwardRef as ReactComponent };